"use client";

import { c as _c } from "react/compiler-runtime";
import { datadogRum, type Site } from "@datadog/browser-rum";
import { useEffect } from "react";
import { shouldIgnoreRumError } from "../lib/shouldIgnoreRumError";
export interface DatadogInitProps {
  env: string;
  version: string;
  service: string;
  clientToken: string;
  applicationId: string;
  site?: Site;
  sessionSampleRate?: number;
  sessionReplaySampleRate?: number;
  trackBfcacheViews?: boolean;
  defaultPrivacyLevel?: "allow" | "mask" | "mask-user-input";
  trackUserInteractions?: boolean;
}
export default function DatadogInit(t0) {
  const $ = _c(13);
  const {
    env,
    version,
    service,
    clientToken,
    applicationId,
    site: t1,
    sessionSampleRate: t2,
    sessionReplaySampleRate: t3,
    trackBfcacheViews: t4,
    defaultPrivacyLevel: t5,
    trackUserInteractions: t6
  } = t0;
  const site = t1 === undefined ? "us3.datadoghq.com" as Site : t1;
  const sessionSampleRate = t2 === undefined ? 100 : t2;
  const sessionReplaySampleRate = t3 === undefined ? 20 : t3;
  const trackBfcacheViews = t4 === undefined ? true : t4;
  const defaultPrivacyLevel = t5 === undefined ? "mask-user-input" : t5;
  const trackUserInteractions = t6 === undefined ? true : t6;
  let t7;
  let t8;
  if ($[0] !== applicationId || $[1] !== clientToken || $[2] !== defaultPrivacyLevel || $[3] !== env || $[4] !== service || $[5] !== sessionReplaySampleRate || $[6] !== sessionSampleRate || $[7] !== site || $[8] !== trackBfcacheViews || $[9] !== trackUserInteractions || $[10] !== version) {
    t7 = () => {
      if (datadogRum.getInitConfiguration()) {
        return;
      }
      datadogRum.init({
        clientToken,
        applicationId,
        site,
        service,
        env: env || "development",
        version: version || "unknown",
        sessionSampleRate,
        sessionReplaySampleRate,
        trackBfcacheViews,
        defaultPrivacyLevel,
        trackUserInteractions,
        beforeSend: _temp
      });
    };
    t8 = [env, version, service, clientToken, applicationId, site, sessionSampleRate, sessionReplaySampleRate, trackBfcacheViews, defaultPrivacyLevel, trackUserInteractions];
    $[0] = applicationId;
    $[1] = clientToken;
    $[2] = defaultPrivacyLevel;
    $[3] = env;
    $[4] = service;
    $[5] = sessionReplaySampleRate;
    $[6] = sessionSampleRate;
    $[7] = site;
    $[8] = trackBfcacheViews;
    $[9] = trackUserInteractions;
    $[10] = version;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  useEffect(t7, t8);
  return null;
}
function _temp(event) {
  if (event.type === "error" && shouldIgnoreRumError(event.error.message)) {
    return false;
  }
  return true;
}